import type { ReactNode } from 'react';
import React from 'react';
import type { RouteComponentProps, RouteProps } from 'react-router-dom';
import { Route, Redirect } from 'react-router-dom';
import { authStore } from 'stores';

type RenderProps = RouteComponentProps;

interface PrivateRouteProps extends Omit<RouteProps, 'children' | 'render'> {
  children?: ReactNode;
  render?: ((props: RenderProps) => ReactNode) | null;
}

const renderComponent = (
  children: ReactNode,
  render: PrivateRouteProps['render'],
  props: RenderProps,
) => {
  return render ? render(props) : children;
};

const PrivateRoute = ({
  children = null,
  render = null,
  ...rest
}: PrivateRouteProps) => {
  const { isLoggedIn } = authStore;

  return (
    <Route
      {...rest}
      render={(props) => {
        return isLoggedIn ? (
          renderComponent(children, render, props)
        ) : (
          <Redirect
            to={{ pathname: '/signin', state: { from: props.location } }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
